const createData = (id: string, name: string, email: string, blacklisted: boolean) => {
  return { id, name, email, blacklisted };
};

export default createData;
